import { render, staticRenderFns } from "./AdminRegistrationIsoLoad.vue?vue&type=template&id=ec147744"
import script from "./AdminRegistrationIsoLoad.vue?vue&type=script&lang=js"
export * from "./AdminRegistrationIsoLoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports